var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 130",
    "aria-hidden": "true",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.31 102.665c21.296 0 38.56-13.988 38.56-31.243S60.607 40.18 39.31 40.18.749 54.167.749 71.422c0 17.255 17.264 31.243 38.56 31.243z",
    fill: "url(#paint0_radial_11393_56126-uid-31)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.31 47.217l-30.82 2.11C3.563 53.973.748 61.15.748 71.424c0 8.303 1.83 14.355 4.926 18.999l36.309-2.534-2.674-40.671zm38.56 24.205c0 7.036-1.267 12.525-3.659 16.747-13.792-4.222-23.08-13.933-23.08-34.339 0-4.785.563-9.007 1.548-12.666C67.315 43.697 77.87 51.578 77.87 71.422z",
    fill: "#746493"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.427 101.963c1.69 4.926 5.208 9.288 10.133 11.681.704.422.422 1.548-.281 1.548-7.319 0-13.933-4.081-17.31-10.414-.704-1.267-1.97-2.111-3.519-2.111 3.66 0 7.459-.282 10.977-.704z",
    fill: "url(#paint1_radial_11393_56126-uid-31)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.31 102.667c3.8 0 7.6-.141 10.978-.704.281.844.703 1.689.985 2.533-.845-1.97-9.289-.985-8.585.141-.563-1.267-1.97-1.97-3.378-1.97z",
    fill: "url(#paint2_linear_11393_56126-uid-31)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.489 47.15L0 48.135l.949 40.94 42.488-.984-.948-40.94z",
    fill: "#95DF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03 89.013l32.228-.703c-.422-12.103-10.273-21.814-22.517-21.814-3.659 0-7.177.845-10.133 2.392l.423 20.125z",
    fill: "url(#paint3_radial_11393_56126-uid-31)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.466 85.636c0 .985.14 1.97.281 2.815l23.784-.563-.422-17.873c-2.111-.845-4.363-1.408-6.755-1.408-9.289.141-16.888 7.74-16.888 17.03z",
    fill: "url(#paint4_radial_11393_56126-uid-31)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.665 74.801l-2.533-23.22a11.72 11.72 0 00-12.947-10.415c-4.222.422-7.74 3.096-9.289 6.755h2.252a10.238 10.238 0 017.318-4.785c5.348-.563 10.133 3.378 10.837 8.726l2.533 23.22c.281 2.956-1.83 5.49-4.644 5.77-2.956.282-5.489-1.829-5.77-4.643l-2.534-23.644c0-.562-.562-.844-1.125-.844s-.845.563-.845 1.126l2.533 23.643a7.13 7.13 0 007.881 6.333c3.941-.422 6.756-4.081 6.333-8.022z",
    fill: "url(#paint5_linear_11393_56126-uid-31)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.675 60.727c.14 0 .14.141 0 0 .844.563 1.83.845 2.815.845.985 0 1.97-.282 2.814-.845 1.267-.844 1.97-2.252 1.97-3.8 0-2.673-2.11-4.784-4.644-4.784-2.533 0-4.785 2.11-4.785 4.644-.14 1.688.704 3.096 1.83 3.94z",
    fill: "url(#paint6_radial_11393_56126-uid-31)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.262 88.025c25.26 0 45.738-16.57 45.738-37.012S124.522 14 99.262 14c-25.26 0-45.739 16.571-45.739 37.013 0 20.441 20.478 37.012 45.739 37.012z",
    fill: "url(#paint7_radial_11393_56126-uid-31)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.174 87.32c-1.97 5.911-6.192 10.978-11.962 13.792-.844.422-.563 1.83.422 1.83 8.725 0 16.606-4.926 20.547-12.385.844-1.548 2.392-2.533 4.222-2.533-4.644.14-9.007-.14-13.229-.704z",
    fill: "url(#paint8_radial_11393_56126-uid-31)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.262 88.165c-4.504 0-9.007-.282-13.088-.704-.282.985-.704 2.11-1.267 3.096.985-2.392 10.977-1.126 10.133.14.985-1.547 2.533-2.532 4.222-2.532z",
    fill: "url(#paint9_linear_11393_56126-uid-31)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.396 52.281a4.745 4.745 0 01-4.785 4.785 4.745 4.745 0 01-4.785-4.785 4.745 4.745 0 014.785-4.785 4.745 4.745 0 014.785 4.785zm8.866-4.785a4.745 4.745 0 00-4.785 4.785 4.745 4.745 0 004.785 4.785 4.745 4.745 0 004.785-4.785 4.745 4.745 0 00-4.785-4.785zm13.792 0a4.745 4.745 0 00-4.785 4.785 4.745 4.745 0 004.785 4.785 4.745 4.745 0 004.785-4.785c0-2.674-2.252-4.785-4.785-4.785z",
    fill: "url(#paint10_linear_11393_56126-uid-31)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11393_56126-uid-31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-17.759 209.364 -100.315) scale(51.1239 38.4718)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BDA1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#B89CE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#A98FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#907AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D77AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11393_56126-uid-31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(141.084 9.866 61.163) scale(8.94615 14.272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D77AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#907AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#9981BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#A88ECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#BDA1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDA1E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_11393_56126-uid-31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.687 81.962) scale(20.6324)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#14A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#139300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_11393_56126-uid-31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(15.81126 11.09454 -12.31954 17.55705 26.942 84.884)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#14A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#139300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_11393_56126-uid-31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.409 55.329) scale(5.64211)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#DEBE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#D8A91A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#C77419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC5118"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_11393_56126-uid-31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(54.2365 0 0 50.5606 94.98 34.926)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F2F7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#ECF2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#DAE4DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E0D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_11393_56126-uid-31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.26638 6.67387 -14.66553 18.165 81.485 90.668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#FBFCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#EEF3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#DAE4DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#D5E0D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11393_56126-uid-31",
    x1: 45.36,
    y1: 104.72,
    x2: 45.36,
    y2: 101.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746493",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746493"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11393_56126-uid-31",
    x1: 9.938,
    y1: 61.925,
    x2: 34.72,
    y2: 61.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#DBE4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EBE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11393_56126-uid-31",
    x1: 92.153,
    y1: 90.621,
    x2: 92.153,
    y2: 80.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AAA97",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AAA97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11393_56126-uid-31",
    x1: 82.772,
    y1: 58.304,
    x2: 115.892,
    y2: 46.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14A800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.b9d96361c7962a6ea1d7a3714c12e188.svg";
export { ForwardRef as ReactComponent };